import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend
} from 'recharts';
import Card from "../ui/card/Card";
import CardTitle from "../ui/card/CardTitle";
import Stack from "../ui/Stack";
import CardList from "../ui/card/CardUlLIst";

const RestaurantInsights = ({ data = {} }) => {
    const summaryData = data?.Summarydata || [];

    if (summaryData.length === 0) return null;

    const chartData = summaryData.map(branch => ({
        name: branch.branchName,
        totalOrders: branch.totalOrders || 0
    }));

    const totalNetworkOrders = chartData.reduce((sum, b) => sum + b.totalOrders, 0);

    return (
        <div className="row my-5">
            <div className="col-12 mb-5">
                <Card className="border-0 p-3 shadow-sm">
                    <Stack>
                        <CardTitle
                            className="mb-5 me-auto"
                            title="Network Performance"
                            subTitle="Branch Comparison"
                        />
                        <CardList
                            className="m-0 text-end"
                            items={[
                                `Total Branches: ${summaryData.length}`,
                                `Combined Orders: ${totalNetworkOrders}`,
                            ]}
                        />
                    </Stack>

                    <div style={{ height: '300px' }} className="mt-4">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 20 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis
                                    dataKey="name"
                                    tick={{ fontSize: 13 }}
                                    angle={-10}
                                    textAnchor="end"
                                />
                                <YAxis tick={{ fontSize: 13 }} />
                                <Tooltip
                                    contentStyle={{
                                        borderRadius: '8px',
                                        border: 'none',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                    }}
                                />
                                <Legend verticalAlign="top" height={36} />
                                <Line
                                    type="monotone"
                                    dataKey="totalOrders"
                                    name="Total Orders"
                                    stroke="#fd7e14"
                                    strokeWidth={1}
                                    activeDot={{ r: 8 }}
                                    animationDuration={1500}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default RestaurantInsights;
